import { IContextualMenuItem } from "@fluentui/react";
import { TableUpdateStrategy } from "../co-panel/ObjectPanelComponent";
import { CoObjectItem } from "../../interfaces/CoObject";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import React, { useEffect, useState } from "react";

interface DocumentPartListUpdateFooterState {
  teachingBubbleVisible: boolean;
  modalVisible: boolean;
  selectedUpdateOption: IContextualMenuItem;
  objectUpdateOption: "DATAFULL" | "DATALESS";
  tableUpdateStrategy: TableUpdateStrategy;
}

export const useDocumentPartListUpdateFooter = (props: {
  selectedObjects: Map<string, CoObjectItem>;
  username: string;
  isNotAuthorized: boolean;
}) => {
  const { selectedObjects, username, isNotAuthorized } = props;
  const getChangesLabel = formatMessage("cof.documentpartupdate.teachingbubble.getchanges.title");
  const getChangesAndUpdateLabel = formatMessage("cof.documentpartupdate.teachingbubble.getchangesfromlowest.title");

  const updateOptions: IContextualMenuItem[] = [
    {
      id: "get_changes_menuitem",
      key: "getChanges",
      text: getChangesLabel,
      depthLevel: "SHALLOWEST",
    },
    {
      id: "get_changes_and_update_menuitem",
      key: "getChangesFromLowestLevel",
      text: getChangesAndUpdateLabel,
      depthLevel: "DEEPEST",
    },
  ];

  const [state, setState] = useState<DocumentPartListUpdateFooterState>({
    teachingBubbleVisible: false,
    modalVisible: false,
    selectedUpdateOption: updateOptions[0],
    objectUpdateOption: "DATALESS",
    tableUpdateStrategy: {
      overrideData: false,
      overrideStyle: false,
      typeUpdate: "update",
    },
  });

  useEffect(() => {
    // Resetta l'opzione di aggiornamento a "update" quando entrambi i toggle sono a false
    if (!state.tableUpdateStrategy.overrideStyle && !state.tableUpdateStrategy.overrideData)
      setState((s) => ({
        ...state,
        tableUpdateStrategy: {
          ...s.tableUpdateStrategy,
          typeUpdate: "update",
        },
      }));
  }, [state.tableUpdateStrategy.overrideStyle, state.tableUpdateStrategy.overrideData]);

  const toggleModal = () => setState({ ...state, modalVisible: !state.modalVisible });

  const setSelectedUpdateOption = (
    _?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
    clickedItem?: IContextualMenuItem
  ) => setState({ ...state, selectedUpdateOption: clickedItem });

  const setObjectUpdateOption = (objectUpdateOption: "DATAFULL" | "DATALESS") => {
    setState((prevState) => ({ ...prevState, objectUpdateOption: objectUpdateOption }));
  };

  const setTeachingBubbleVisible = (teachingBubbleVisible: boolean) => {
    setState((prevState) => ({ ...prevState, teachingBubbleVisible }));
  };

  const setTableUpdateStrategy = (tableUpdateStrategy: TableUpdateStrategy) => {
    setState((prevState) => ({ ...prevState, tableUpdateStrategy }));
  };

  const setModalVisible = (modalVisible: boolean) => {
    setState((prevState) => ({ ...prevState, modalVisible }));
  };

  const infoId = "UpdatesPageInfoId";

  const disabled = selectedObjects.size == 0 || isNotAuthorized;

  return {
    state,
    selectedObjects,
    infoId,
    disabled,
    updateOptions,
    username,
    setSelectedUpdateOption,
    setObjectUpdateOption,
    setTeachingBubbleVisible,
    setTableUpdateStrategy,
    setModalVisible,
    toggleModal,
  };
};
